module.exports = __webpack_public_path__ + "static/fonts/Poppins-Regular.093ee89.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Regular.ttf
// module id = 1031
// module chunks = 11